import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ReportEntryPage() {
  const navigate = useNavigate();

  const cards = [
    {
      id: 'dmr',
      title: 'DMR Entry Form',
      description: 'Enter direct material records manually against projects.',
      icon: '📦',
      route: '/report-entry/dmr',
      color: 'var(--brand)',
      bg: 'linear-gradient(135deg, rgba(34,211,238,0.1), rgba(11,49,139,0.05))',
    },
    // {
    //   id: 'qs',
    //   title: 'QS Entry Form',
    //   description: 'Record QS installation and measurement data.',
    //   icon: '📐',
    //   route: '/report-entry/qs',
    //   color: '#10b981',
    //   bg: 'linear-gradient(135deg, rgba(16,185,129,0.1), rgba(16,185,129,0.02))',
    // },
    {
      id: 'bulk-qs',
      title: 'QS Entry Form',
      description: 'Record multiple QS installation and measurement entries rapidly.',
      icon: '📋',
      route: '/report-entry/bulk-qs',
      color: '#3b82f6',
      bg: 'linear-gradient(135deg, rgba(59,130,246,0.1), rgba(59,130,246,0.02))',
    },
    {
      id: 'boq',
      title: 'BOQ Entry Form',
      description: 'Upload and digitize new Bill of Quantities items.',
      icon: '📊',
      route: '/report-entry/boq',
      color: '#8b5cf6',
      bg: 'linear-gradient(135deg, rgba(139,92,246,0.1), rgba(139,92,246,0.02))',
    },
    {
      id: 'labour',
      title: 'Labour Entry Form',
      description: 'Log and track site labour entry timesheets.',
      icon: '👷',
      route: '/report-entry/coming-soon?module=Labour Entry Register',
      color: '#f59e0b',
      bg: 'linear-gradient(135deg, rgba(245,158,11,0.1), rgba(245,158,11,0.02))',
    }
  ];

  return (
    <div className="fade-in" style={{ padding: '24px 26px' }}>
      <div style={{ marginBottom: 20 }}>
        <p style={{ fontSize: 14, color: 'var(--text-secondary)', margin: 0 }}>
          Select a form type below to begin data entry.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: 16 }}>
        {cards.map(card => (
          <div
            key={card.id}
            onClick={() => {
              navigate(card.route);
            }}
            style={{
              background: '#e2e8f0',
              border: '2px solid #000',
              borderRadius: '12px',
              padding: '24px',
              cursor: 'pointer',
              boxShadow: '0 15px 30px rgba(0, 0, 0, 0.55)',
              transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
              display: 'flex', flexDirection: 'column', gap: 12
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = '#cbd5e1';
              e.currentTarget.style.borderColor = 'var(--accent)';
              e.currentTarget.style.boxShadow = '0 36px 64px rgba(0, 0, 0, 0.65)';
              e.currentTarget.style.transform = 'translateY(-6px)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = '#e2e8f0';
              e.currentTarget.style.borderColor = '#000';
              e.currentTarget.style.boxShadow = '0 15px 30px rgba(0, 0, 0, 0.55)';
              e.currentTarget.style.transform = 'none';
            }}
          >
            <div style={{ fontSize: 32 }}>
              {card.icon}
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a' }}>{card.title}</div>
                {card.route.includes('coming-soon') && (
                  <span style={{ fontSize: 10, fontWeight: 700, background: '#cbd5e1', color: '#475569', padding: '2px 8px', borderRadius: 999 }}>Coming Soon</span>
                )}
              </div>
              <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{card.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
